module.exports = __webpack_public_path__ + "img/MESSENGER_2.e7a1c07a.png";